import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import FileUploadIcon from '@mui/icons-material/CloudUpload';

const styles = (theme:Theme):any => ({
  container: {
    display: 'flex',
    justifyContent:'flex-start',
    alignItems: 'center'
  },
  preview: {
    width:200,
    height: 40,
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1)
  },
  input: {
    display: 'none',
  },
  hidden: {
    display: 'none'
  },
  visible: {
    display: 'flex'
  }
});

class FFileField extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      loading: false,
      open: false,
      source: undefined
    };
  }

  onChange = (event:any) => {
    event.persist();
    let that = this;
    let file:any, fr:any;
    let files:any = event.target.files || event.dataTransfer.files;
    if(files) {
      file = files[0];
      fr = new FileReader();
      fr.onload = function createImage() {
        that.setState({source:fr.result});
        if(that.props.onChange) that.props.onChange(event.target.name)(event,file);
        //console.log('source set, onChange called');
      };
      fr.readAsDataURL(file);
    }
  }

  render() {
    const {id,name,children,preview,previewStyle,divider,classes} = this.props;
    const {source} = this.state;
    //var accept = "image/*";
    return (
      <div>
      <div className={classes.container}>
        <input
          //accept={accept}
          className={classes.input}
          id={id}
          name={name}
          type="file"
          onChange={this.onChange}
        />
        <label htmlFor={id}>
          <Button variant="contained" component="span" className={classes.button}>
            <FileUploadIcon color={'inherit'}/>
            {children}
          </Button>
        </label>
        {preview&&<img className={source?classes.preview:classes.hidden} style={previewStyle||{}} src={source} alt={""}/>}
      </div>
      {divider && <Divider />}
      </div>
    );
  }
}

FFileField.propTypes = {
  classes: PropTypes.object.isRequired,
  //children: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
};

export default withStyles(styles)(FFileField);
